import { render, staticRenderFns } from "./modal_tag_list.vue?vue&type=template&id=6c97896c&scoped=true&"
import script from "./modal_tag_list.vue?vue&type=script&lang=js&"
export * from "./modal_tag_list.vue?vue&type=script&lang=js&"
import style0 from "./modal_tag_list.vue?vue&type=style&index=0&id=6c97896c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97896c",
  null
  
)

export default component.exports